import { nsHistorics } from '@/app/i18n/namespaces';

const HISTORICS_USER_TYPE = {
    MANAGEMENT: { name: 'MANAGEMENT', entity: 'users.MANAGEMENT', namespace: nsHistorics },
    MERCHANT: { name: 'MERCHANT', entity: 'users.MERCHANT', namespace: nsHistorics }
};

export default HISTORICS_USER_TYPE;